import cornerUrl from "@/assets/images/corner.svg";
import arrowUrl from "@/assets/images/arrow-up.svg";
import faviconUrl from "@/public/Favicon.svg";

export const CORNER_SRC = cornerUrl;
export const ARROW_SRC = arrowUrl;
export const FAVICON_SRC = faviconUrl;

export function IconTabResult({ className }) {
  return (
    <svg className={className} width="16" height="16" viewBox="0 0 16 16" aria-hidden="true">
      <path
        fill="#524749"
        d="M1.2 2.2h13.6v2.5H1.2V2.2zm1.15 3.55h4.35v7.15H2.35V5.75zm6 0h4.35v7.15H8.35V5.75z"
      />
    </svg>
  );
}

export function IconFilter({ className }) {
  return (
    <svg className={className} width="24" height="24" viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="12" r="12" fill="#EBEBEB" />
      <path
        d="M6.4 8.15h5.15L9.7 10.55v2.55l-1.7.75v-3.05L6.4 8.15z"
        fill="none"
        stroke="#231E1F"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <rect x="13.15" y="7.85" width="5.1" height="1.15" rx="0.3" fill="#0D0D0D" />
      <rect x="13.15" y="10.55" width="4.15" height="1.15" rx="0.3" fill="#0D0D0D" />
      <rect x="13.15" y="13.25" width="3.15" height="1.15" rx="0.3" fill="#0D0D0D" />
    </svg>
  );
}

export function IconSearch({ className, size = 24 }) {
  return (
    <svg className={className} width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="#3A3A3A"
        d="M10.6 3.9a6.7 6.7 0 014.9 11.25l3.55 3.55a1 1 0 01-1.42 1.42l-3.55-3.55A6.7 6.7 0 1110.6 3.9zm0 1.9a4.8 4.8 0 100 9.6 4.8 4.8 0 000-9.6z"
      />
    </svg>
  );
}

export function IconClose({ className }) {
  return (
    <svg className={className} width="24" height="24" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M7 7l10 10M17 7L7 17" stroke="#808080" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

export function IconClear({ className }) {
  return (
    <svg className={className} width="12" height="12" viewBox="0 0 12 12" aria-hidden="true">
      <path d="M2.6 2.6l6.8 6.8M9.4 2.6L2.6 9.4" stroke="#000" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  );
}

export function IconCheck({ className }) {
  return (
    <svg className={className} width="12" height="12" viewBox="0 0 24 24" aria-hidden="true">
      <path
        d="M5 12.5l4.2 4.2L19 7.2"
        fill="none"
        stroke="#4D4D4D"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

